<template>
  <div class="sun-supply-strategy" v-loading="loading">
    <div class="head_body">
      <el-form ref="form" :model="filter" class="search_head" label-width="120px">
        <el-row :gutter="20" class="list-head">
          <el-col :span="5">
            <el-form-item :label="$t('sunStrategy.plan_name')">
              <el-input v-model="filter.programme_name" :placeholder="$t('sunStrategy.input_plan_name')" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="search-btn-box">
              <el-button type="primary" size="small" @click="headSearch"><svg-icon name="search"></svg-icon>{{$t('control.search')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h_line"></div>
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>{{$t('control.add')}}</el-button
          >
        </div>
      </div>
      <div class="h20"></div>
      <el-table 
        :data="tableData"
        style="width: 100%"
        ref="table"
        class="nowrap-table"
        >
        <el-table-column prop="programme_id" label="ID" align="center" sortable :min-width="100"></el-table-column>
        <el-table-column prop="programme_name" :label="$t('sunStrategy.plan_name')" align="center" :min-width="180"></el-table-column>
        <el-table-column prop="model_name" :label="$t('sunStrategy.device_model_id')" align="center" :min-width="140"></el-table-column>
        <el-table-column prop="run_mode" :label="$t('sunStrategy.run_mode')"  align="center" :min-width="140">
          <template slot-scope="scope">
            {{ runModeArr[scope.row.run_mode] }}
          </template>
        </el-table-column>
        <el-table-column prop="switch_mode" :label="$t('sunStrategy.switch_mode')"  align="center" :min-width="140">
          <template slot-scope="scope">
            {{ switchModeArr[scope.row.switch_mode] }}
          </template>
        </el-table-column>
        <el-table-column prop="start_time" :label="$t('sunStrategy.start_time')" align="center" :min-width="140"></el-table-column>
        <el-table-column prop="create_at" :label="$t('sunStrategy.create_by')" align="center" :min-width="120"></el-table-column>
        <el-table-column prop="edit" :label="$t('control.operate')" fixed="right" :min-width="110">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.programme_id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      
    </div>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>
    

    <!-- 新增修改路灯策略 开始 -->
     
    <el-dialog
      v-if="dialogVisible"
      class="normal_dialog big-dialog"
      :title="editType === 'create' ? $t('control.add') : $t('control.edit')"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="editOne"
        ref="editOneRef"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-row :gutter="20" class="item-list">
            <el-col :span="12">
              <el-form-item :label="$t('sunStrategy.device_model')">
                <el-select
                  :placeholder="$t('sunStrategy.device_model')"
                  v-model="editOne.device_type"
                  style="width: 100%"
                  @change="changeDeviceType"
                  filterable
                  :disabled="editType === 'create'?false:true"
                >
                  <el-option
                    v-for="(t,index) in supplyTypeArr"
                    :key="index"
                    :label="t.type_name"
                    :value="t.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('sunStrategy.plan_name')" prop="programme_name" required>
                <el-input v-model="editOne.programme_name" :placeholder="$t('sunStrategy.input_plan_name')"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="24">
              设备ID: {{selectItem.id}}<br/>
              设备的type值: {{selectItem.type}}是“{{selectItem.type==1?'市电互补':'太阳能'}}”设备,<br/>
              设备的run_mode值: {{editOne.run_mode}}是“{{runModeArr[editOne.run_mode]}}”
            </el-col> -->
            <template v-if="selectItem.id">
              <el-col v-if="selectItem.switch_mode_ids&&selectItem.switch_mode_ids.length" :span="24">
                <el-form-item label="运行模式">
                    <el-radio-group v-model="editOne.switch_mode">
                        <el-radio 
                          v-for="id in selectItem.switch_mode_ids" 
                          :key="id" 
                          :label="id" 
                        >
                          {{ switchModeArr[id] }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="峰值保护" prop="peak_prot_val" required>
                  <el-col :span="16">
                    <el-input v-model="editOne.peak_prot_val" placeholder="请输入峰值保护"></el-input>
                  </el-col>
                  <el-col
                    v-if="selectItem.peak_prot&&selectItem.peak_prot.length"
                    :span="8"
                    >
                    ({{selectItem.peak_prot[0]||0}} ~ {{selectItem.peak_prot[1]||'∞'}})
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="欠压保护" prop="vol_prot_val" required>
                  <el-col :span="16">
                    <el-input v-model="editOne.vol_prot_val" placeholder="请输入欠压保护"></el-input>
                  </el-col>
                  <el-col
                    v-if="selectItem.vol_prot&&selectItem.vol_prot.length"
                    :span="8"
                    >
                    ({{selectItem.vol_prot[0]||0}} ~ {{selectItem.vol_prot[1]||'∞'}})
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="退出欠压保护" prop="quit_prot_val" required>
                  <el-col :span="16">
                    <el-input v-model="editOne.quit_prot_val" placeholder="请输入退出欠压保护"></el-input>
                  </el-col>
                  <el-col
                    v-if="selectItem.quit_prot&&selectItem.quit_prot.length"
                    :span="8"
                    >
                    ({{selectItem.quit_prot[0]||0}} ~ {{selectItem.quit_prot[1]||'∞'}})
                  </el-col>
                </el-form-item>
              </el-col>
              <div v-if="editOne.switch_mode==2">
                <el-col :span="12">
                  <el-form-item label="降功率起始点" prop="start_point" required>
                    <el-col :span="16">
                      <el-input v-model="editOne.start_point" placeholder="请输入降功率起始点"></el-input>
                    </el-col>
                    <el-col
                    v-if="selectItem.redu_start_point&&selectItem.redu_start_point.length"
                    :span="8"
                    >
                    ({{selectItem.redu_start_point[0]||0}} ~ {{selectItem.redu_start_point[1]||'∞'}})
                  </el-col>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="降功率终止点" prop="end_point" required>
                    <el-col :span="16">
                      <el-input v-model="editOne.end_point" placeholder="请输入降功率终止点"></el-input>
                    </el-col>
                    <el-col
                    v-if="selectItem.redu_end_point&&selectItem.redu_end_point.length"
                    :span="8"
                    >
                    ({{selectItem.redu_end_point[0]||0}} ~ {{selectItem.redu_end_point[1]||'∞'}})
                  </el-col>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="降功率起始百分比" prop="start_per" required>
                    <el-col :span="16">
                      <el-input v-model="editOne.start_per" placeholder="请输入降功率起始百分比"></el-input>
                    </el-col>
                    <el-col
                    v-if="selectItem.redu_start_per&&selectItem.redu_start_per.length"
                    :span="8"
                    >
                    ({{selectItem.redu_start_per[0]||0}} ~ {{selectItem.redu_start_per[1]||'∞'}})
                  </el-col>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="降功率终止百分比" prop="end_per" required>
                    <el-col :span="16">
                      <el-input v-model="editOne.end_per" placeholder="请输入降功率终止百分比"></el-input>
                    </el-col>
                    <el-col
                    v-if="selectItem.redu_end_per&&selectItem.redu_end_per.length"
                    :span="8"
                    >
                    ({{selectItem.redu_end_per[0]||0}} ~ {{selectItem.redu_end_per[1]||'∞'}})
                  </el-col>
                  </el-form-item>
                </el-col>
              </div>

              <el-col v-if="selectItem.running_mode_ids&&selectItem.running_mode_ids.length" :span="24">
                <el-form-item label="开关灯控制模式">
                    <el-radio-group v-model="editOne.run_mode">
                        <el-radio 
                            v-for="id in selectItem.running_mode_ids" 
                            :key="id" 
                            :label="id" 
                        >
                            {{ runModeArr[id] }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
              </el-col>
              <!-- if(id==89){
    
                  if (run_mode == 2){
                      // 界面1 的条件
                  }

                  if (run_mode == 4){
                      // 界面1 的条件
                  }
                  // 界面2 的条件
              }else{
                  if(run_mode == 1){ // * run_mode=1 
                      
                      if(type==0){ // run_mode=1, type = 0 (太阳能)
                          // 2222
                      }else if(type==1){ // run_mode=1, type = 1 (市电互补)
                          // 3333
                      }   
                  }

                  if(run_mode == 4){  // * run_mode=4
                      // 4444
                  }
              } -->

              
              <!-- if(selectItem.id==89) -->
              <div v-if="selectItem.id===89">
                <!-- id为89的设备，run_mode=2 市电开市电关 -->
                <template v-if="editOne.run_mode===2">
                  <el-col :span="12">
                    <el-form-item label="负载电流(mA)" prop="electricity" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.electricity" placeholder="请输入负载电流(mA)"></el-input>
                      </el-col>
                      <el-col
                      v-if="selectItem.run_elec&&selectItem.run_elec.length"
                      :span="8"
                      >
                      ({{selectItem.run_elec[0]||0}} ~ {{selectItem.run_elec[1]||'∞'}})
                    </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="充电电流" prop="illu_point" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.illu_point" placeholder="请输入充电电流"></el-input>
                      </el-col>
                      <el-col
                      v-if="selectItem.illu_point&&selectItem.illu_point.length"
                      :span="8"
                      >
                      ({{selectItem.illu_point[0]||0}} ~ {{selectItem.illu_point[1]||'∞'}})
                    </el-col>
                    </el-form-item>
                  </el-col>
                  <!-- 1条 -->
                  <el-col :span="7">
                    <el-form-item label="第一段持续时间" prop="time_one" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.time_one"></el-input> 
                      </el-col>
                      <el-col :span="8">min</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="2">
                    <el-form-item label="电流" prop="elec_one" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.elec_one"></el-input> 
                      </el-col>
                      <el-col :span="8">mA</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" :offset="2">
                    <el-form-item>
                      <el-radio-group v-model="editOne.illu_one">
                          <el-radio :label="0">市电优先</el-radio>
                          <el-radio :label="1">太阳能优先</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>

                  <!-- 2条 -->
                  <el-col :span="7">
                    <el-form-item label="第一段持续时间" prop="time_two" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.time_two"></el-input> 
                      </el-col>
                      <el-col :span="8">min</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="2">
                    <el-form-item label="电流" prop="elec_two" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.elec_two"></el-input> 
                      </el-col>
                      <el-col :span="8">mA</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" :offset="2">
                    <el-form-item>
                      <el-radio-group v-model="editOne.illu_two">
                          <el-radio :label="0">市电优先</el-radio>
                          <el-radio :label="1">太阳能优先</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>

                  <!-- 3条 -->
                  <el-col :span="7">
                    <el-form-item label="第三段持续时间" prop="time_three" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.time_three"></el-input> 
                      </el-col>
                      <el-col :span="8">min</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="2">
                    <el-form-item label="电流" prop="elec_three" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.elec_three"></el-input> 
                      </el-col>
                      <el-col :span="8">mA</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" :offset="2">
                    <el-form-item>
                      <el-radio-group v-model="editOne.illu_three">
                          <el-radio :label="0">市电优先</el-radio>
                          <el-radio :label="1">太阳能优先</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>

                  <!-- 4条 -->
                  <el-col :span="7">
                    <el-form-item label="第四段持续时间" prop="time_four" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.time_four"></el-input> 
                      </el-col>
                      <el-col :span="8">min</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="2">
                    <el-form-item label="电流" prop="elec_four" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.elec_four"></el-input> 
                      </el-col>
                      <el-col :span="8">mA</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" :offset="2">
                    <el-form-item>
                      <el-radio-group v-model="editOne.illu_four">
                          <el-radio :label="0">市电优先</el-radio>
                          <el-radio :label="1">太阳能优先</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>

                  <!-- 5条 -->
                  <el-col :span="7">
                    <el-form-item label="第五段持续时间" prop="time_five" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.time_five"></el-input> 
                      </el-col>
                      <el-col :span="8">min</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="2">
                    <el-form-item label="电流" prop="elec_five" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.elec_five"></el-input> 
                      </el-col>
                      <el-col :span="8">mA</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" :offset="2">
                    <el-form-item>
                      <el-radio-group v-model="editOne.illu_five">
                          <el-radio :label="0">市电优先</el-radio>
                          <el-radio :label="1">太阳能优先</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  
                </template>
                
                <!-- id为89的设备，run_mode=4 时控开灯-时控关灯 -->
                <template v-if="editOne.run_mode===4">
                  <el-col :span="12">
                    <el-form-item label="开始时间" prop="start_time" required>
                      <el-time-select
                        v-model="editOne.start_time"
                        :picker-options="{
                          start: '00:00',
                          step: '00:10',
                          end: '24:00'
                        }"
                        placeholder="选择时间"
                        style="width: 200px;"
                        >
                      </el-time-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="结束时间" prop="end_time" required>
                      <el-time-select
                        v-model="editOne.end_time"
                        :picker-options="{
                          start: '00:00',
                          step: '00:10',
                          end: '24:00'
                        }"
                        placeholder="选择时间"
                        style="width: 200px;"
                        >
                      </el-time-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="负载电流(mA)" prop="electricity" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.electricity" placeholder="请输入负载电流(mA)"></el-input>
                      </el-col>
                      <el-col
                      v-if="selectItem.run_elec&&selectItem.run_elec.length"
                      :span="8"
                      >
                      ({{selectItem.run_elec[0]||0}} ~ {{selectItem.run_elec[1]||'∞'}})
                    </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="充电电流" prop="illu_point" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.illu_point" placeholder="请输入充电电流"></el-input>
                      </el-col>
                      <el-col
                      v-if="selectItem.illu_point&&selectItem.illu_point.length"
                      :span="8"
                      >
                      ({{selectItem.illu_point[0]||0}} ~ {{selectItem.illu_point[1]||'∞'}})
                    </el-col>
                    </el-form-item>
                  </el-col>
                  <!-- 1条 -->
                  <el-col :span="7">
                    <el-form-item label="第一段持续时间" prop="time_one" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.time_one"></el-input> 
                      </el-col>
                      <el-col :span="8">min</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="2">
                    <el-form-item label="电流" prop="elec_one" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.elec_one"></el-input> 
                      </el-col>
                      <el-col :span="8">mA</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" :offset="2">
                    <el-form-item>
                      <el-radio-group v-model="editOne.illu_one">
                          <el-radio :label="0">市电优先</el-radio>
                          <el-radio :label="1">太阳能优先</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>

                  <!-- 2条 -->
                  <el-col :span="7">
                    <el-form-item label="第一段持续时间" prop="time_two" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.time_two"></el-input> 
                      </el-col>
                      <el-col :span="8">min</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="2">
                    <el-form-item label="电流" prop="elec_two" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.elec_two"></el-input> 
                      </el-col>
                      <el-col :span="8">mA</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" :offset="2">
                    <el-form-item>
                      <el-radio-group v-model="editOne.illu_two">
                          <el-radio :label="0">市电优先</el-radio>
                          <el-radio :label="1">太阳能优先</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>

                  <!-- 3条 -->
                  <el-col :span="7">
                    <el-form-item label="第三段持续时间" prop="time_three" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.time_three"></el-input> 
                      </el-col>
                      <el-col :span="8">min</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="2">
                    <el-form-item label="电流" prop="elec_three" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.elec_three"></el-input> 
                      </el-col>
                      <el-col :span="8">mA</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" :offset="2">
                    <el-form-item>
                      <el-radio-group v-model="editOne.illu_three">
                          <el-radio :label="0">市电优先</el-radio>
                          <el-radio :label="1">太阳能优先</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>

                  <!-- 4条 -->
                  <el-col :span="7">
                    <el-form-item label="第四段持续时间" prop="time_four" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.time_four"></el-input> 
                      </el-col>
                      <el-col :span="8">min</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="2">
                    <el-form-item label="电流" prop="elec_four" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.elec_four"></el-input> 
                      </el-col>
                      <el-col :span="8">mA</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" :offset="2">
                    <el-form-item>
                      <el-radio-group v-model="editOne.illu_four">
                          <el-radio :label="0">市电优先</el-radio>
                          <el-radio :label="1">太阳能优先</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>

                  <!-- 5条 -->
                  <el-col :span="7">
                    <el-form-item label="第五段持续时间" prop="time_five" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.time_five"></el-input> 
                      </el-col>
                      <el-col :span="8">min</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="2">
                    <el-form-item label="电流" prop="elec_five" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.elec_five"></el-input> 
                      </el-col>
                      <el-col :span="8">mA</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" :offset="2">
                    <el-form-item>
                      <el-radio-group v-model="editOne.illu_five">
                          <el-radio :label="0">市电优先</el-radio>
                          <el-radio :label="1">太阳能优先</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>

                </template>
              </div>
              <div v-else>
                <!-- run_mode = 1-->
                <div v-if="editOne.run_mode==1">
                  <el-col :span="12">
                    <el-form-item label="负载电流(mA)" prop="electricity" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.electricity" placeholder="请输入负载电流(mA)"></el-input>
                      </el-col>
                      <el-col
                      v-if="selectItem.run_elec&&selectItem.run_elec.length"
                      :span="8"
                      >
                      ({{selectItem.run_elec[0]||0}} ~ {{selectItem.run_elec[1]||'∞'}})
                    </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="光照度(Lux)" prop="illu_point" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.illu_point" placeholder="请输入光照度(Lux)"></el-input>
                      </el-col>
                      <el-col
                      v-if="selectItem.illu_point&&selectItem.illu_point.length"
                      :span="8"
                      >
                      ({{selectItem.illu_point[0]||0}} ~ {{selectItem.illu_point[1]||'∞'}})
                    </el-col>
                    </el-form-item>
                  </el-col>
                  <!-- this.selectItem.type = 0 太阳能 -->
                  <template v-if="this.selectItem.type==0">
                    run_mode = 1，this.selectItem.type==0
                    <!-- 1条 -->
                    <el-col :span="6">
                      <el-form-item label="第一段持续时间" prop="time_one" required>
                        <el-col :span="16">
                          <el-input v-model="editOne.time_one"></el-input> 
                        </el-col>
                        <el-col :span="8">min</el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="10" :offset="1">
                      <el-form-item label="亮度">
                        <el-slider v-model="editOne.illu_one" show-input></el-slider>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5" :offset="2">
                      <el-form-item label="电流" prop="elec_one" required>
                        <el-col :span="16">
                          <el-input v-model="editOne.elec_one"></el-input> 
                        </el-col>
                        <el-col :span="8">mA</el-col>
                      </el-form-item>
                    </el-col>

                    <!-- 2条 -->
                    <el-col :span="6">
                      <el-form-item label="第二段持续时间" prop="time_two" required>
                        <el-col :span="16">
                          <el-input v-model="editOne.time_two"></el-input> 
                        </el-col>
                        <el-col :span="8">min</el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="10" :offset="1">
                      <el-form-item label="亮度">
                        <el-slider v-model="editOne.illu_two" show-input></el-slider>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5" :offset="2">
                      <el-form-item label="电流" prop="elec_two" required>
                        <el-col :span="16">
                          <el-input v-model="editOne.elec_two"></el-input> 
                        </el-col>
                        <el-col :span="8">mA</el-col>
                      </el-form-item>
                    </el-col>

                    <!-- 3条 -->
                    <el-col :span="6">
                      <el-form-item label="第三段持续时间" prop="time_three" required>
                        <el-col :span="16">
                          <el-input v-model="editOne.time_three"></el-input> 
                        </el-col>
                        <el-col :span="8">min</el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="10" :offset="1">
                      <el-form-item label="亮度">
                        <el-slider v-model="editOne.illu_three" show-input></el-slider>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5" :offset="2">
                      <el-form-item label="电流" prop="elec_three" required>
                        <el-col :span="16">
                          <el-input v-model="editOne.elec_three"></el-input> 
                        </el-col>
                        <el-col :span="8">mA</el-col>
                      </el-form-item>
                    </el-col>

                    <!-- 4条 -->
                    <el-col :span="6">
                      <el-form-item label="第四段持续时间" prop="time_four" required>
                        <el-col :span="16">
                          <el-input v-model="editOne.time_four"></el-input> 
                        </el-col>
                        <el-col :span="8">min</el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="10" :offset="1">
                      <el-form-item label="亮度">
                        <el-slider v-model="editOne.illu_four" show-input></el-slider>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5" :offset="2">
                      <el-form-item label="电流" prop="elec_four" required>
                        <el-col :span="16">
                          <el-input v-model="editOne.elec_four"></el-input> 
                        </el-col>
                        <el-col :span="8">mA</el-col>
                      </el-form-item>
                    </el-col>
                  </template>
                  
                  <!-- this.selectItem.type = 1 市电互补 -->
                  <template v-if="this.selectItem.type==1">
                    <!-- 1条 -->
                    <el-col :span="7">
                      <el-form-item label="第一段持续时间" prop="time_one" required>
                        <el-col :span="16">
                          <el-input v-model="editOne.time_one"></el-input> 
                        </el-col>
                        <el-col :span="8">min</el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="7" :offset="2">
                      <el-form-item label="电流" prop="elec_one" required>
                        <el-col :span="16">
                          <el-input v-model="editOne.elec_one"></el-input> 
                        </el-col>
                        <el-col :span="8">mA</el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" :offset="2">
                      <el-form-item>
                        <el-radio-group v-model="editOne.illu_one">
                            <el-radio :label="0">市电优先</el-radio>
                            <el-radio :label="1">太阳能优先</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>

                    <!-- 2条 -->
                    <el-col :span="7">
                      <el-form-item label="第一段持续时间" prop="time_two" required>
                        <el-col :span="16">
                          <el-input v-model="editOne.time_two"></el-input> 
                        </el-col>
                        <el-col :span="8">min</el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="7" :offset="2">
                      <el-form-item label="电流" prop="elec_two" required>
                        <el-col :span="16">
                          <el-input v-model="editOne.elec_two"></el-input> 
                        </el-col>
                        <el-col :span="8">mA</el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" :offset="2">
                      <el-form-item>
                        <el-radio-group v-model="editOne.illu_two">
                            <el-radio :label="0">市电优先</el-radio>
                            <el-radio :label="1">太阳能优先</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>

                    <!-- 3条 -->
                    <el-col :span="7">
                      <el-form-item label="第三段持续时间" prop="time_three" required>
                        <el-col :span="16">
                          <el-input v-model="editOne.time_three"></el-input> 
                        </el-col>
                        <el-col :span="8">min</el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="7" :offset="2">
                      <el-form-item label="电流" prop="elec_three" required>
                        <el-col :span="16">
                          <el-input v-model="editOne.elec_three"></el-input> 
                        </el-col>
                        <el-col :span="8">mA</el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" :offset="2">
                      <el-form-item>
                        <el-radio-group v-model="editOne.illu_three">
                            <el-radio :label="0">市电优先</el-radio>
                            <el-radio :label="1">太阳能优先</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>

                    <!-- 4条 -->
                    <el-col :span="7">
                      <el-form-item label="第四段持续时间" prop="time_four" required>
                        <el-col :span="16">
                          <el-input v-model="editOne.time_four"></el-input> 
                        </el-col>
                        <el-col :span="8">min</el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="7" :offset="2">
                      <el-form-item label="电流" prop="elec_four" required>
                        <el-col :span="16">
                          <el-input v-model="editOne.elec_four"></el-input> 
                        </el-col>
                        <el-col :span="8">mA</el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" :offset="2">
                      <el-form-item>
                        <el-radio-group v-model="editOne.illu_four">
                            <el-radio :label="0">市电优先</el-radio>
                            <el-radio :label="1">太阳能优先</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </template>
                </div>

                <!-- run_mode = 4-->
                <div v-if="editOne.run_mode==4">
                  <el-col :span="24">
                    <el-form-item label="开始时间" prop="start_time" required>
                      <el-time-select
                        v-model="editOne.start_time"
                        :picker-options="{
                          start: '00:00',
                          step: '00:10',
                          end: '24:00'
                        }"
                        placeholder="选择时间"
                        style="width: 200px;"
                        >
                      </el-time-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="负载电流(mA)" prop="electricity" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.electricity" placeholder="请输入负载电流(mA)"></el-input>
                      </el-col>
                      <el-col
                      v-if="selectItem.run_elec&&selectItem.run_elec.length"
                      :span="8"
                      >
                      ({{selectItem.run_elec[0]||0}} ~ {{selectItem.run_elec[1]||'∞'}})
                    </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="光照度(Lux)" prop="illu_point" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.illu_point" placeholder="请输入光照度(Lux)"></el-input>
                      </el-col>
                      <el-col
                      v-if="selectItem.illu_point&&selectItem.illu_point.length"
                      :span="8"
                      >
                      ({{selectItem.illu_point[0]||0}} ~ {{selectItem.illu_point[1]||'∞'}})
                    </el-col>
                    </el-form-item>
                  </el-col>
                  
                  <!-- 1条 -->
                  <el-col :span="7">
                    <el-form-item label="第一段持续时间" prop="time_one" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.time_one"></el-input> 
                      </el-col>
                      <el-col :span="8">min</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="2">
                    <el-form-item label="电流" prop="elec_one" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.elec_one"></el-input> 
                      </el-col>
                      <el-col :span="8">mA</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" :offset="2">
                    <el-form-item>
                      <el-radio-group v-model="editOne.illu_one">
                          <el-radio :label="0">市电优先</el-radio>
                          <el-radio :label="1">太阳能优先</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>

                  <!-- 2条 -->
                  <el-col :span="7">
                    <el-form-item label="第一段持续时间" prop="time_two" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.time_two"></el-input> 
                      </el-col>
                      <el-col :span="8">min</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="2">
                    <el-form-item label="电流" prop="elec_two" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.elec_two"></el-input> 
                      </el-col>
                      <el-col :span="8">mA</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" :offset="2">
                    <el-form-item>
                      <el-radio-group v-model="editOne.illu_two">
                          <el-radio :label="0">市电优先</el-radio>
                          <el-radio :label="1">太阳能优先</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>

                  <!-- 3条 -->
                  <el-col :span="7">
                    <el-form-item label="第三段持续时间" prop="time_three" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.time_three"></el-input> 
                      </el-col>
                      <el-col :span="8">min</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="2">
                    <el-form-item label="电流" prop="elec_three" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.elec_three"></el-input> 
                      </el-col>
                      <el-col :span="8">mA</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" :offset="2">
                    <el-form-item>
                      <el-radio-group v-model="editOne.illu_three">
                          <el-radio :label="0">市电优先</el-radio>
                          <el-radio :label="1">太阳能优先</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>

                  <!-- 4条 -->
                  <el-col :span="7">
                    <el-form-item label="第四段持续时间" prop="time_four" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.time_four"></el-input> 
                      </el-col>
                      <el-col :span="8">min</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="2">
                    <el-form-item label="电流" prop="elec_four" required>
                      <el-col :span="16">
                        <el-input v-model="editOne.elec_four"></el-input> 
                      </el-col>
                      <el-col :span="8">mA</el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" :offset="2">
                    <el-form-item>
                      <el-radio-group v-model="editOne.illu_four">
                          <el-radio :label="0">市电优先</el-radio>
                          <el-radio :label="1">太阳能优先</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>


                </div>
              </div>

            </template>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="box-footer">
          <el-button class="cancel-btn" size="medium" @click="dialogVisible = false">{{$t('control.cancel')}}</el-button>
          <el-button v-if="editType === 'create'" type="primary" size="medium" @click="createItem">{{$t('control.confirm')}}</el-button>
          <el-button v-if="editType === 'update'" type="primary" size="medium" @click="updateItem">{{$t('control.confirm')}}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增修改路灯策略 结束 -->
  </div>
</template>
<script>
import commonJs from '@/utils/common'
import time from "@/utils/time";
import planApi from "@/api/device/sunStrategy"
export default {
  data() {
    return {
      loading: false,
      runModeArr: this.$t('sunStrategy.run_mode_arr'),
      switchModeArr: this.$t('sunStrategy.switch_mode_arr'),
      supplyTypeArr: [],
      tableData: [],
      pageInfo: {
        filter: '',
        page: 1,
        pageSize: 20
      },
      filter: {
        strategy_type: 1,
        title: '',
        run_model: '',
        is_double: ''
      },
      cnt_all: 0,
      dialogVisible: false,
      editOneRule: {
        device_type: [{ required: true, message: this.$t('sunStrategy.device_model'), trigger: "blur" }],
        programme_name: [{ required: true, message: this.$t('sunStrategy.plan_name'), trigger: "blur" }]
      },
      selectItem: {
        id: null
      },
      editType: -1,
      editOne: {}
    };
  },
  mounted() {
    this.getSupplyType()
    this.getTableData(this.pageInfo.page)
  },
  methods: {
    ...time,
    getTableData(pageIndex) {
      this.tableData = []
      this.pageInfo.filter = ''
      this.loading = true;
      this.pageInfo.page = pageIndex;
      let filter = this.filter;
      filter = filter && commonJs.obj.removeNullKey(filter);
      if (filter && Object.keys(filter).length) {
        this.pageInfo.filter = JSON.stringify(filter);
      }
      planApi.strategyList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      })
    },
    getSupplyType() {
      planApi.supplyType().then((res) => {
        if (res.data.code === 1000) {
          const resData = res.data.data
          if(resData.length){
            const newResData = resData.filter(item => (item.type === 1 || item.type === 0) && item.id > 0 && item.peak_prot);
            this.supplyTypeArr = newResData;
          }else{
            this.supplyTypeArr = []
          }
        }
      })
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    openEditWin(index) {
      if (index === "create") {
        this.resetEditOne()
        this.editType = "create"
        this.dialogVisible = true;
      } else {
        this.editType = "update";
        const isDeviceTypeValid = this.changeDeviceType(index.device_type);
        if (!isDeviceTypeValid) {
          return
        }
        let editItem = JSON.parse(JSON.stringify(index));
        // 删除指定的键
        delete editItem.create_by
        delete editItem.update_by
        delete editItem.update_at
        this.editOne = editItem
        this.dialogVisible = true
      }
    },
    resetEditOne (){
      this.editOne = {
        programme_id: 0,
        programme_name: '',
        device_type: '',
        run_mode: 0,
        switch_mode: 0,
        start_time: '',
        end_time: '',
        end_time: '',
        time_one: '',
        time_two: '',
        time_three: '',
        time_four: '',
        time_five: '',
        elec_one: '',
        elec_two: '',
        elec_three: '',
        elec_four: '',
        elec_five: '',
        illu_one: 0,
        illu_two: 0,
        illu_three: 0,
        illu_four: 0,
        illu_five: 0,
        electricity: '',
        charging_current: '',
        vol_prot_val: '',
        peak_prot_val: '',
        quit_prot_val: '',
        start_point: '',
        end_point: '',
        illu_point: '',
        start_per: '',
        end_per: '',
        solarboard_type: '',
        charging_switch: ''
      };
    },
    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 20
      this.getTableData(1)
    },
    createItem() {
      this.$refs.editOneRef.validate((valid) => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.editOne))
          delete params.programme_id
          planApi.strategyAdd(params).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.add_success'));
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          })
        } else {
          return false
        }
      })

    },
    updateItem() {
      this.$refs.editOneRef.validate((valid) => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.editOne))
          delete params.programme_id
          planApi.strategyEdit(this.editOne.programme_id, params).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.mod_success'))
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          return false
        }
      })
    },
    delItem(id) {
      this.$confirm(this.$t('lampStrategy.delete_strategy_tip'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
        .then(() => {
          planApi.strategyDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$popupMessage({
                type: 'success',
                title: this.$t('control.del_success')
                // msg: '如果未刷新，请耐心等待5秒，点击刷新列表查看结果'
              })
              this.getTableData(this.pageInfo.page);
            } else {
              this.$popupMessage({
                type: 'error',
                title: this.$t('control.tip'),
                msg: res.data.message
              })
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del'),
          });
        });
    },
    changeDeviceType(e) {
      if(this.editType != "update"){
        this.resetEditOne()
      }
      
      if(e){
        let foundItem = this.supplyTypeArr.find(item => item.id === e);
        if (foundItem) {
          // 遍历对象的属性，将字符串形式的数组转换为实际数组
          for (let key in foundItem) {
              if (typeof foundItem[key] === 'string' && foundItem[key].startsWith('[') && foundItem[key].endsWith(']')) {
                foundItem[key] = JSON.parse(foundItem[key]); // 转换为数组
              }
          }
          this.selectItem = foundItem
          this.editOne.device_type = e
          this.editOne.peak_prot_val = this.selectItem.peak_prot?.[2] || '';
          this.editOne.vol_prot_val = this.selectItem.vol_prot?.[2] || '';
          this.editOne.quit_prot_val = this.selectItem.quit_prot?.[2] || '';
          this.editOne.start_point = this.selectItem.redu_start_point?.[2] || '';
          this.editOne.end_point = this.selectItem.redu_end_point?.[2] || '';
          this.editOne.start_per = this.selectItem.redu_start_per?.[2] || '';
          this.editOne.end_per = this.selectItem.redu_end_per?.[2] || '';

          this.editOne.electricity = this.selectItem.run_elec?.[2] || '';
          this.editOne.illu_point = this.selectItem.illu_point?.[2] || '';

          this.editOne.run_mode = this.selectItem.running_mode_ids?.[0] || 0;
          this.editOne.switch_mode = this.selectItem.switch_mode_ids?.[0] || 0;
          return true;
        } else {
          this.$message.error('错误，该设备类型ID不在库中')
          this.dialogVisible = false;
          return false
        }
      }else{
        this.selectItem.id  = null
        this.$message.error(this.$t('sunStrategy.device_model'))
        return false
      }
    }
  }
  
};
</script>
<style lang='less'>
@color-primary:#0c82fe;
.sun-supply-strategy{
  width: 100%;
  .el-form-item__content{
    .el-col{
      padding-left: 0 !important;
    }
  }
  .item-list{
    .el-col-12{
      padding-left: 10px !important;
      padding-right: 10px !important;
    }
  }
}
</style>
